import getters from './getters';
import mutations from './mutations';
import actions from './actions';

export default {
	state: {
		users: [],
		roles: []
	},
	actions,
	mutations,
	getters
};
